import templateStr from 'text!./templates/service-request-message-list.html';

export default ['$state', '$injector', ($state, $injector) => {
    return {
        restrict: 'A',
        scope: {
            messages: '='
        },
        template: (tElement, tAttrs) => {
            if (angular.isDefined(tAttrs.globalTemplate)) {
                const str = $injector.get(tAttrs.globalTemplate);
                return str || templateStr;
            }
            return templateStr;
        },
        link: (scope) => {
            scope.tableConfig = {
                paginationSize: 1000
            };

            scope.goToServiceRequest = (requestNumber) => {
                const state = $state.get('serviceRequestDetails');
                $state.transitionTo(state, {
                    serviceRequestNumber: requestNumber
                });
            };

            scope.viewMessage = (message, isReply) => {
                const state = $state.get('viewReplyMessage');
                state.data.message = message;
                $state.transitionTo(state, {
                    serviceRequestNumber: message.serviceRequestNumber,
                    reply: isReply,
                    previousState: $state.$current.name
                });
            };
        }
    };
}];
